import { SearchIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";
import ContactList from "../contact/ContactList";
import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { getContacts } from "../../api/endpoints/chat/conversations";
import { ApiResponse } from "../../api/apiResponse";
import toast from "react-hot-toast";

export default function ContactListContainer() {
  const LocalBasePath = "page.chat";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [contactList, setContactsList] = useState([]);
  const { currentUser }: any = useAuth();

  const getContactsList = async () => {
    const response: ApiResponse = await getContacts({
      ActorId: currentUser?.id,
      ActorType: currentUser?.object_type,
    });
    if (response.isSuccess) {
      const { data } = response;
      setContactsList(data ?? []);
    } else {
      response.errorMessages.forEach((errorMessage) => {
        toast.error(errorMessage);
      });
    }
  };
  useEffect(() => {
    if (currentUser?.object_type?.toLowerCase() !== "candidate") {
      getContactsList();
    }
  }, []);
  return (
    <div className="w-full bg-white">
      <div className="sticky top-0 z-20 bg-white flex flex-col gap-[18px] px-[21px] py-7  ">
        <h2 className="text-lg leading-6 font-medium text-gray-900">
          {t("messages")}
        </h2>
        <div className="relative rounded-md shadow-sm">
          <div className="absolute inset-y-0 start-0 ps-3  flex items-center pointer-events-none">
            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
            type="text"
            name="search"
            id="search"
            className="block w-full ps-10 border border-gray-300 focus:ring-brandblue-500 focus:border-brandblue-500 text-sm rounded-md"
            placeholder={t("searchByName")}
          />
        </div>
      </div>
      <div className="w-full flex flex-col">
        <h3 className="z-10 sticky  border-t border-b border-gray-300 bg-gray-100 px-6 py-2 flex justify-between	 text-xs  text-gray-900">
          <span>{t("contacts")}</span>
          <span>{contactList?.length}</span>
        </h3>
        {contactList.length > 0 && <ContactList contactList={contactList} />}
      </div>
    </div>
  );
}
